import * as React from "react";
import DeletePanel from "../../components/CustomDelete/DeletePanel";
import strings from "../../config/localization";
import { useDeleteResourceTypeMutation } from "../../services/appln";

export default function DeleteResourceType(props: any): any {
  return (
    <DeletePanel
      useIcon={true}
      deleteMutation={useDeleteResourceTypeMutation}
      deleteArgs={{ id: props.id }}
      buttonLabel={strings.delete}
      confirmationDialogTitle={strings.deleteResourceTypeTitle}
      confirmationDialogMsg={strings.deleteResourceTypeConfirmation}
      errorDialogTitle={strings.deleteResourceTypeFailedTitle}
      errorDialogMsg={strings.deleteResourceTypeFailedMsg}
    />
  );
}
